<template lang="html">
  <article
    class="charger"
    :class="{
      'charger--not-available': props.connector.status !== 'AVAILABLE'
    }"
    @click="connectorClicked"
  >
    <div class="charger__left" :class="classType">
      <span class="charger__letter">
        {{ connector.label }}
      </span>
      <img
        class="charger__icon"
        :src="`${config.imagesPath}/charger-${connectorTypeSlug}.svg`"
        alt=""
      />
    </div>
    <h3 class="charger__type">
      {{ connectorTypeName }}
    </h3>
    <div class="charger__info">
      <img
        v-if="connector.mode === 'DC'"
        class="charger__info-icon"
        src="@/assets/images/charger-dc-icon.svg"
        alt=""
      />
      <img
        v-else
        class="charger__info-icon"
        src="@/assets/images/charger-ac-icon.svg"
        alt=""
      />
      <span class="charger__info-text">
        {{ connector.mode === "DC" ? "DC" : "AC" }} | {{ connector.voltage }}V |
        {{ connector.current }}A
      </span>
    </div>
    <div
      v-if="connector.connectorFormat === 'CABLE'"
      class="charger__has-cable"
    >
      <picture class="charger__has-cable-icon">
        <source
          srcset="@/assets/images/charger-has-cable-dark.svg"
          media="(prefers-color-scheme: dark)"
        />
        <img src="@/assets/images/charger-has-cable.svg" alt="" />
      </picture>
      <span class="charger__has-cable-text">
        {{ $t("chargingPage.connectorLayout.hasCable") }}
      </span>
    </div>
    <div class="charger__price">
      {{ price }}
    </div>
    <div class="charger__power">
      <img
        class="charger__power-icon"
        src="@/assets/images/charger-power.svg"
        alt=""
      />
      <span class="charger__power-text"
        >{{ connector.power ? connector.power / 1000 : "N/a" }} kW</span
      >
    </div>
  </article>
</template>

<script lang="ts" setup>
import { PriceService } from "@/services/price-service"
import config from "../../config"
import { computed } from "vue"
import { useI18n } from "vue-i18n"
import { chargerTypes, chargerTypesFromBackend } from "@/models/common"
import type { Connector } from "@/models/common"

interface ConnectorComponentProps {
  connector: Connector
}

const props = withDefaults(defineProps<ConnectorComponentProps>(), {
  connector: () => ({
    id: "",
    type: "",
    status: "",
    power: undefined
  })
})

const emit = defineEmits(["clicked"])

const i18n = useI18n()

const classType = computed(() => {
  return props.connector.status === "AVAILABLE"
    ? "charger__left--available"
    : "charger__left--not-available"
})

const price = computed(() => {
  return PriceService.getPriceLabel(props.connector.price, i18n)
})

const connectorTypeSlug = computed(() => {
  const connectorType = props.connector.connectorType
  return connectorType ? chargerTypesFromBackend[connectorType] : "type2"
})

const connectorTypeName = computed(() => {
  return chargerTypes[connectorTypeSlug.value] ?? chargerTypes.type2
})

const connectorClicked = () => {
  if (props.connector.status === "AVAILABLE") {
    emit("clicked", props.connector)
  }
}
</script>
